import { observer } from 'mobx-react-lite'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import { AppointmentSectionContainer } from '@/features/jobs/details/consultation/components/AppointmentSection'
import { ProInfoSectionContainer } from '@/features/jobs/details/components/ProInfoSection'
import { InlineResponsesSectionContainer } from '@/features/jobs/details/components/InlineResponsesSection'
import { SupportSectionContainer } from '@/features/jobs/details/components/SupportSection/SupportSectionContainer'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import type ConsultationManagerViewModel from '@/features/jobs/details/consultation/ConsultationManagerViewModel'

interface ConsultationJobOverviewTabProps {
  vm: JobDetailsViewModel
  consultationManagerVm: ConsultationManagerViewModel
  displayContactSupport: boolean
}

export const ConsultationJobOverviewTab = observer(
  function ConsultationJobOverviewTab({
    vm,
    consultationManagerVm,
    displayContactSupport,
  }: ConsultationJobOverviewTabProps) {
    return (
      <PageLayout
        asideTop={<ProInfoSectionContainer vm={vm} />}
        asideBottom={displayContactSupport && <SupportSectionContainer />}
      >
        <AppointmentSectionContainer vm={consultationManagerVm} />
        <InlineResponsesSectionContainer vm={vm.questionsDisplayVm} />
      </PageLayout>
    )
  },
)
